import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Card, CardContent, CircularProgress, ClickAwayListener, Divider, Grid, Grow, ListItemIcon, ListItemText, MenuItem, MenuList, Paper, Popper, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from '@material-ui/core';
import React, { useState } from 'react'
import { FiMinusCircle, FiPlusCircle } from 'react-icons/fi';
import Backdrop from '../../../components/Modal/Backdrop';
import Modal from '../../../components/Modal/Modal';
import { useStyles } from './styles'
import axiosInstance from '../../../environment/axiosInstance'
import ProductsTableBody from './ProductsTableBody';
import PlacesAutocomplete, {
    geocodeByAddress,
    getLatLng,
} from 'react-places-autocomplete';
import { Link } from 'react-router-dom';

function Products() {
    const classes = useStyles();
    const [openExpand, setOpenExpand] = React.useState(true);
    const tableHeader = ['Name', 'phoneNumber', 'phoneName', 'Mac Address', 'staus',];
    const [loading, setLoading] = React.useState(false);
    const [products, setProducts] = React.useState([]);
    const [search, setSearch] = useState("");

    const expandOpen = () => {
        setOpenExpand(!openExpand)
    }



    //api integration
    const fetchProducts = () => {
        setLoading(true)
        axiosInstance.get('/support/business_owner/product').then((res: any) => {
            // console.log('desk', res)
            if (res.status === 200) {
                setLoading(false);
                setProducts(res.data.Data)
            }

        }).catch((err: any) => {

        });
    }

    React.useEffect(() => {
        fetchProducts()
    }, [])


    return (
        <div>
            <Card className={classes.card}>
                <Accordion expanded={openExpand}
                    onChange={expandOpen}>
                    <AccordionSummary
                        expandIcon={openExpand ? <FiMinusCircle color="#2645ad" onClick={expandOpen} /> : <FiPlusCircle color="#2645ad" onClick={expandOpen} />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                    >
                        <Typography className={classes.heading}>My Products</Typography>
                    </AccordionSummary>
                    <Divider className={classes.divider} />
                    <div className={classes.cardBody}>
                        <Grid container spacing={2}>
                            <Grid item md={4}>
                                {/* <TextField
                                    size='small'
                                    fullWidth
                                    placeholder='search'
                                    value={search}
                                    name='search'
                                    //onChange={(e: any) => setSearch(e.target.value)}
                                    onChange={handleDeskphoneName}
                                    variant='outlined'

                                /> */}
                            </Grid>
                            <Grid item md={2}></Grid>
                            <Grid item md={6}>
                                <Link
                                    to="/dashboard/settings/products/add"
                                    className={classes.gridItem + " " + classes.addArticleLink}
                                >
                                    Add Product
                                </Link>
                            </Grid>
                        </Grid>
                        <Card className={classes.cardStyles}>
                            <TableContainer>
                                <Table className={classes.table}>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell className={classes.tableName}>Sr. #</TableCell>
                                            <TableCell className={classes.tableName}>Name</TableCell>
                                            <TableCell className={classes.tableName}>Status</TableCell>
                                            <TableCell className={classes.tableName}>Action</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {loading ?
                                            <Box>
                                                <div style={{ position: "absolute", width: "100%", textAlign: "center" }}>
                                                    <CircularProgress />
                                                </div>
                                            </Box> 
                                            :
                                            products.length > 0 && (
                                                products.filter((itm: any) => itm.name.toLowerCase().includes(search.toLowerCase()))
                                                    .map((roomData, i) => <ProductsTableBody
                                                        roomData={roomData}
                                                        products={products}
                                                        i={i}
                                                        fetchProducts={fetchProducts}
                                                    />
                                                    )
                                            )
                                        }
                                    </TableBody>
                                </Table>
                                {
                                    products?.length <= 0 && <p style={{ textAlign: 'center', padding: 10 }}>No products found</p>
                                }
                            </TableContainer>
                        </Card>
                    </div>
                </Accordion>
            </Card>
        </div>
    )
}

export default Products